// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
// require("turbolinks").start()
require("@rails/activestorage").start();
require("channels");
require("jquery-ui");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//

import 'bootstrap';
import "select2";
// shakapacker 8 の resolve.extensions は JS 系のみのため拡張子を明示する
import '../stylesheets/application.scss';
import 'common/ui';
import 'common/drop_area';
import 'invoice/new';
import 'invoice/index';
import 'user/import';

global.$ = jQuery;